<template>
    <div>
        <!----------------------------------------Select encadrant ----------------------------------------->
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="user_reinforcements">Choisissez le Professionnel *</label>
                    <select name="user_reinforcements" v-model="enc" class="form-control" id="user_reinforcements">
                        <option v-for="(enc, index) in encadrant" :value="enc" :style="(bookingmultipleenc!=null&&index<bookingmultipleenc.length)?'background-color:orange':''" v-bind:key="index">{{typeof enc.email_hash === 'undefined'?+enc.priority+1:+enc.pivot.priority+1}}★ - {{enc.fullName}}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group">
                    <label for="quantity" class="text-nowrap">Quantité *</label>
                    <input type="number" name="quantity" id="quantity" ref="input" class="form-control" v-model.number="quantity" />
                </div>
            </div>
            <div v-show="!officecustomization|| !officecustomization.hasOwnProperty('honorairesType') || officecustomization.honorairesType=='percent' || officecustomization.honorairesType=='both' || forceType=='percent'" class="col-md-2">
                <div class="form-group">
                    <label for="percentage">Masses du bureau (en %)*</label>
                    <input type="number" name="percentage" id="percentage" ref="input" class="form-control" v-model="percentage" @input="honoChange($event,'percent')" step="0.01"/>
                </div>
            </div>
            <div v-show="officecustomization!=null && officecustomization.hasOwnProperty('honorairesType') && officecustomization.honorairesType=='both'" class="col-md-1">OU</div>
            <div v-show="officecustomization!=null && officecustomization.hasOwnProperty('honorairesType') && (officecustomization.honorairesType=='euro' || officecustomization.honorairesType=='both' || forceType=='part')" class="col-md-2">
                <div class="form-group">
                    <label>Part du pro (en €)*</label>
                    <input type="number" name="part" id="part" ref="input" class="form-control" v-model="part" @input="honoChange($event,'part')" step="0.01"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-offset-3 col-md-3">
                <span>Part du pro pour l'activité : </span>
                <h4 class="badge badge-primary">{{computeProHonoraire()}} €</h4>
            </div>
            <div class="col-md-2 text-center">
                <a class="btn btn-success billingSuccess" @click.prevent="addEncadrant()">Valider</a>
            </div>
        </div>
        <!-------------------------------------------- end select encadrant--------------------------------------->

        <div id="errors_valid" v-show="errors != false" class="alert alert-danger">Veuillez sélectionner un professionnel, remplir le champ "Quantité", un seul des deux champs : "Masses" ou "Part" et vérifier que vous avez bien ajouté une activité.
        </div>
        <div id="error_hono" hidden="" class="alert alert-danger"></div>

        <!---------------Store enc---------------------->
        <template v-for="(enc,idx) in value">
            <input type="hidden" :value="enc.id" name="guidessup[]" id="guidesSup" v-bind:key="'enc_'+idx"/>
            <input type="hidden" :value="enc.part" name="parts[]"  v-bind:key="'encPart_'+idx"/>
        </template>
        <template v-for="(renfort,idx) in renfortsValue">
            <input type="hidden" :value="renfort.id" name="renfortssup[]" id="renfortsSup"  v-bind:key="'renf_'+idx"/>
            <input type="hidden" :value="renfort.part" name="renfortsparts[]" v-bind:key="'renfPart_'+idx"/>
        </template>

        <!-- ----------------------table------------------>
        <!--<table class="table table-striped" v-if="this.value.length >0 || this.renfortsValue.length >0">
            <thead>
            <tr>
                <th>Nom du pro</th>-->
                <!-- <th>Honoraires de l'activité</th>-->
                <!--<th></th>
            </tr>
            </thead>
            <tbody>-->
            <!-- -----------------------salarie--------------------------------->
            <!--<tr v-for="enc in value" v-show="enc.presta == prestation">
                <td>{{ enc.fullName }}</td>
                <td>{{ enc.part }} €</td>
                <input type="hidden" :value="enc.id" name="guidessup[]" id="guidesSup"/>
                <input type="hidden" :value="enc.part" name="parts[]" />
                <td>
                    <a href="javascript:;" class="btn btn-danger pull-right" @click="deleteUser(enc)"><i class="fa fa-trash"></i></a>
                    <a href="javascript:;" class="btn btn-primary pull-right" @click="updateUser(enc)"><i class="fas fa-pencil-alt"></i></a>
                </td>
            </tr>-->

            <!-- -----------------------renfort--------------------------------->
            <!--<tr v-for="renfort in renfortsValue" v-show="renfort.presta == prestation">
                <td>{{ renfort.name }}</td>
                <td>{{ renfort.part }} €</td>
                <input type="hidden" :value="renfort.id" name="renfortssup[]" id="renfortsSup"/>
                <input type="hidden" :value="renfort.part" name="renfortsparts[]" />
                <td>
                    <a href="javascript:;" class="btn btn-danger pull-right" @click="deleteRenfort(renfort)"><i class="fa fa-trash"></i></a>
                    <a href="javascript:;" class="btn btn-primary pull-right" @click="updateRenfort(renfort)"><i class="fas fa-pencil-alt"></i></a>
                </td>
            </tr>
            </tbody>
        </table>-->
    </div>
</template>

<script>
    export default {

        name: 'selectBillingEncadrantBureau',
        props: ['usersReinforcement','renfortsReinforcement','isencadrantsalarie', 'hasmodulefacturebureau', 'officeencadrant','prestation','oldDetails','officecustomization','hasbilling','bookingmultipleenc'],
        data () {
            return {
                'value': Object.assign([], this.usersReinforcement),//store added user
                'renfortsValue': Object.assign([], this.renfortsReinforcement),//store added renfort
                'user': '',
                'enc': '',
                'renfort': '',
                'part': '',
                'quantity': '',
                'percentage':'',
                'errors' : false,
                'forceType':'',
               /* 'encadrant': 'salarie',*/
                'encadrant': this.getEncList()
            }
        },
        computed: {
            price() {
                let price = 0
                for (var i = this.value.length - 1; i >= 0; i--) {
                    (price += this.value[i].part)
                }
                this.$parent.$emit('update:totalDispatchedPrice', {
                    'type' : 'user',
                    'quantity' : price
                })
                return price
            }
        },
        watch:{
            value: function(val){
                this.$emit('change',this.value,this.renfortsValue)
            },
            renfortsValue: function(val){
                this.$emit('change',this.value,this.renfortsValue)
            }
        },
        methods: {
            getEncList(){
                let vm = this
                let sorted = _.sortBy(this.officeencadrant,function (enc) {
                    let forcePriority = "1"//for string :  0>1
                    if(vm.bookingmultipleenc!==null){//put bookingMultipleEnc first
                        if(vm.bookingmultipleenc.some(bookingEnc => bookingEnc.id==enc.id&&bookingEnc.hasOwnProperty('email_hash')==enc.hasOwnProperty('email_hash'))){
                            forcePriority="0"//0 => higher priority than 1
                        }
                    }
                    let priority = typeof enc.email_hash === 'undefined'?enc.priority:enc.pivot.priority;
                    priority = forcePriority+(4-priority)+"_"+enc.fullName.toLowerCase();//4-prior => to invert priority 4 must be before 0
                    return priority
                })
                return Object.assign([],sorted)
            },
            addEncadrant(){
                $("#error_hono").hide()
                this.forceType=''
                if (this.enc != '' && typeof this.enc.email_hash === 'undefined') {
                    this.addRenfort()
                }else{
                    this.addUser()
                }
            },
            honoChange(event,honoType){
                if(this.officecustomization!=null && this.officecustomization.hasOwnProperty('honorairesType') && this.officecustomization.honorairesType=='both'){
                    let error={hasError:false}
                    if(honoType=="percent" && (this.part || this.part === 0)){
                        error = {hasError:true,clear:"la part",input:"les masses",reset:"percentage",highlight:"part"};
                    }else if(honoType=="part" && (this.percentage || this.precentage === 0)){
                        error = {hasError:true,clear:"les masses",input:"la part",reset:"part",highlight:"percentage"};
                    }else{
                        $("#error_hono").hide()
                    }
                    if(error.hasError){
                        $("#error_hono").text("Veuillez effacer "+error.clear+" du pro si vous souhaitez rentrer "+error.input+".").show()
                        this[error.reset]=''
                        $("#"+error.highlight).parent().addClass("has-error").delay(1000).queue(function(next){
                            $(this).removeClass("has-error");
                            next();
                        });
                    }
                }
            },
            addUser() {//load user + part(honoraire) to enc and push it to value, remove it from select and reset form
                //check to avoid duplicate encadrant for the same prestation
                if (this.enc != '' && !this.findEnc(this.value, this.enc['id'],this.prestation.billingActivityId)&&this.quantity!=''&&(typeof this.percentage!== 'undefined' && this.percentage!==''|| typeof this.part !== 'undefined' && this.part!=='')) {
                    if((this.percentage || this.percentage===0) && (this.part && this.part===0)){
                        this.errors=true
                    }else{
                        let tempEnc = this.deepCopy(this.enc)
                        //si encadrant existe déja sur une autre  ne pas modifier ou utiliser la meme reference
                        if(this.percentage || this.percentage === 0){
                            tempEnc['part'] = this.computeProHonoraire()//honoraire
                            tempEnc['percentage'] = this.percentage
                            tempEnc['setWithPart'] = false
                        }else{
                            tempEnc['percentage'] = this.computePercentage()
                            tempEnc['part']=this.part
                            tempEnc['setWithPart'] = true
                        }
                        tempEnc['presta'] = this.prestation.billingActivityId
                        tempEnc['quantity'] = this.quantity
                        this.value.push(tempEnc)
                        //this.encadrant.splice(this.encadrant.indexOf(this.enc), 1)//remove encadrant from select for the same activity id
                        this.part = ''
                        this.enc  = ''
                        this.quantity = ''
                        this.percentage = ''
                        this.errors = false
                    }
                }else{
                    this.errors = true
                }
            },

            addRenfort() {
                //check to avoid duplicate encadrant for the same prestation
                if (this.enc != '' && !this.findEnc(this.renfortsValue, this.enc['id'],this.prestation.billingActivityId) &&this.quantity!=''&&(typeof this.percentage!== 'undefined' && this.percentage!==''|| typeof this.part !== 'undefined' && this.part!=='')) {
                    if(this.percentage!='' && this.part!=''){
                        this.errors=true
                    }else{
                        let tempEnc = this.deepCopy(this.enc)
                        if(this.percentage!=''){
                            tempEnc['part'] = this.computeProHonoraire()//honoraire
                            tempEnc['percentage'] = this.percentage
                            tempEnc['setWithPart'] = false
                        }else{
                            tempEnc['percentage'] = this.computePercentage()
                            tempEnc['part']=this.part
                            tempEnc['setWithPart'] = true
                        }
                        tempEnc['presta'] = this.prestation.billingActivityId
                        tempEnc['quantity'] = this.quantity
                        this.renfortsValue.push(tempEnc)
                       // this.encadrant.splice(this.encadrant.indexOf(this.enc), 1)
                        this.part = ''
                        this.enc = ''
                        this.quantity = ''
                        this.percentage = ''
                        this.errors = false
                    }
                }else{
                    this.errors = true
                }
            },
            deleteEncsByPresta(prestaID)
            {
                let users = this.findEncs(this.value,prestaID)
                let renfs = this.findEncs(this.renfortsValue,prestaID)
                for(let user in users)
                {
                    this.deleteUser(users[user])
                }
                for(let renf in renfs)
                {
                    this.deleteRenfort(renfs[renf])
                }
            },
            deleteUser(user) {//add user to select and remove it from value
                //this.encadrant.push(user)
                this.value.splice(this.value.indexOf(user), 1)
            },
            deleteRenfort(renfort) {
                //this.encadrant.push(renfort)
                this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
            },
            updateUser(user) {//remove user from value and load data in form
                //this.encadrant.push(user)
                this.enc = this.encadrant.find(function(element) {
                  return element.id==user.id && typeof element.email_hash !== 'undefined';
                });
                if(user.hasOwnProperty('setWithPart')&&user.setWithPart==true){
                    this.part = user.part
                    this.percentage=""
                    this.forceType="part"
                }else{
                    this.percentage = user.percentage
                    this.part=""
                    this.forceType="percent"
                }
                this.quantity = user.quantity
                this.value.splice(this.value.indexOf(user), 1)
                this.$refs.input.focus()
            },
            updateRenfort(renfort) {
                //this.encadrant.push(renfort)
                this.enc = this.encadrant.find(function(element) {
                  return element.id==renfort.id && typeof element.email_hash === 'undefined';
                });
                if(renfort.hasOwnProperty('setWithPart')&&renfort.setWithPart==true){
                    this.part = renfort.part
                    this.percentage=""
                    this.forceType="part"
                }else{
                    this.percentage = renfort.percentage
                    this.part=""
                    this.forceType="percent"
                }
                this.quantity = renfort.quantity
                this.renfortsValue.splice(this.renfortsValue.indexOf(renfort), 1)
                this.$refs.input.focus()
            },
            findEnc(encs,proID,prestaID)//get one encadrant for a prestation
            {
                return encs.find(function(element) {
                  return element.id==proID && element.presta==prestaID;
                });
            },
            findEncs(encs,prestaID)//get all encadrant for a prestation
            {
                return encs.filter(function(element){
                    return element.presta==prestaID
                });
            },
            deepCopy(src) {//to remove reference
                return JSON.parse(JSON.stringify(src))
            },
            //pro honoraire for a given prestation (detail)
            computeProHonoraire(){
                if($.isNumeric(this.quantity) && $.isNumeric(this.percentage)){
                    return (this.prestation.price*this.quantity*(100-this.percentage)/100).toFixed(2)//invert masses percentage to get pro percentage
                }else{
                    if($.isNumeric(this.part)){
                        return this.part
                    }else{
                        return 0
                    }
                }
            },
            computePercentage(){
                if($.isNumeric(this.quantity)&&$.isNumeric(this.part)){
                    return (1-((this.part/this.quantity)/this.prestation.price)) *100
                }else{
                    return 0
                }
            },
            loadOldEnc()//load json info of saved encadrant
            {
                let alreadyLoaded = []//when one enc is in multiple presta duplicate enc
                for(let d in this.oldDetails){
                    for(let e in this.oldDetails[d].enc){
                        let encID = this.oldDetails[d].enc[e].id
                        let enc = {}
                        if(this.oldDetails[d].enc[e].isRenfort){
                            enc = this.renfortsValue.find(function(element){return encID==element.id})
                            if(!alreadyLoaded.includes(encID)){
                                alreadyLoaded.push(encID)
                            }else{
                                enc=this.renfortsValue[this.renfortsValue.push(this.deepCopy(enc))-1]//-1 because push return length not index
                            }
                        }else{
                            enc = this.value.find(function(element){return encID==element.id})
                            if(!alreadyLoaded.includes(encID)){
                                alreadyLoaded.push(encID)
                            }else{
                                enc = this.value[this.value.push(this.deepCopy(enc)) -1]//-1 because push return length not index
                            }
                        }
                        if(this.oldDetails[d].enc[e].hasOwnProperty('setWithPart')&&this.oldDetails[d].enc[e].setWithPart==true){
                            enc['part'] = this.oldDetails[d].enc[e].part
                            enc['percentage'] = (1-((this.oldDetails[d].enc[e].part/this.oldDetails[d].enc[e].quantity)/this.oldDetails[d].price))*100
                            enc['setWithPart']=true
                        }else{
                             enc['percentage'] = this.oldDetails[d].enc[e].percentage
                             enc['part'] = (this.oldDetails[d].price*this.oldDetails[d].enc[e].quantity*(100-this.oldDetails[d].enc[e].percentage)/100).toFixed(2)
                             enc['setWithPart']=false
                        }
                        enc['presta'] = this.oldDetails[d].billingActivityId
                        enc['quantity'] = this.oldDetails[d].enc[e].quantity
                    }
                }
            }

            //price to use to compute honoraire depending on how many pro in the selected prestation
           /** getPriceToComputeHonoraire(prestation){
                return prestation.price/this

            },**/

            //get all encadrant for a given prestation
           /** getEncForGivenPrestation(){
                //
                return encs.filter(function (element) {
                    return element.presta == prestaID

                })
            }**/

        },
        mounted () {
            this.$parent.$on('update:totalDispatchedPrice', (e) => {
                this.part = e.quantity
            })

            this.$root.$on('encDelete', (proID,prestaID,isRenfort) => {
              if(isRenfort)
              {
                this.deleteRenfort(this.findEnc(this.renfortsValue,proID,prestaID))
              }
              else
              {
                this.deleteUser(this.findEnc(this.value,proID,prestaID))
              }
            });
            this.$root.$on('encUpdate',(proID,isRenfort) => {
                if(isRenfort)
                {
                    //wait for this.prestation to update
                    this.$nextTick(() => {this.updateRenfort(this.findEnc(this.renfortsValue,proID,this.prestation.billingActivityId))})
                }
                else
                {
                    //wait for this.prestation to update
                    this.$nextTick(() => {this.updateUser(this.findEnc(this.value,proID,this.prestation.billingActivityId))})
                }
            });

            this.$root.$on('prestaDelete',(prestaID)=>{
                this.deleteEncsByPresta(prestaID)
            });

            if(this.oldDetails.length >0)//on edit
            {
                this.loadOldEnc()
            }

            if(this.hasbilling || this.bookingmultipleenc!=null){
                if(this.value.length>0){
                    this.$nextTick(() => {this.updateUser(this.value[0])})

                }else if(this.renfortsValue.length>0){
                    this.$nextTick(() => {this.updateRenfort(this.renfortsValue[0])})
                }
            }
        },
    }
</script>

<style lang="css" scoped>
    .valign{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8.4rem;
    }
</style>
